import * as angular from 'angular';
import {AgentRequests} from "../../agents/services/agent-requests.service";
import {BringozLoaderService} from "../../commons/services/bringoz-loader.service";
import {WalletsRequests} from "./wallets-requests.service";

export class WalletsService {

  constructor(private walletsRequests: WalletsRequests, private agentRequests: AgentRequests,
              private bringozLoaderService: BringozLoaderService, private $log) {
  }

  getAgentsTotalBalance() {
    return new Promise((resolve, reject) => {
      this.bringozLoaderService.on();
      this.walletsRequests.getAgentsTotalBalance()
        .then((balance) => {
          resolve(balance);
        })
        .catch((error) => {
          this.$log.error(error);
          reject(error)
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    })
  }

}

angular
  .module('bringoz.admin.wallets')
  .service('WalletsService', WalletsService);
